











































import { Component, Vue, Prop } from "vue-property-decorator";
import ListAction from "./ListAction";

@Component({
  components: { ListAction }
})
class MixinAccount extends Vue {
  @Prop() meta;

  loading = false;

  bindAvaliable = true;

  handleBind() {
    this.$common.utils.helper.requestBindMixin(this);
  }

  async handleUnBind() {
    this.loading = true;
    await this.$api.account.unBindMixin();
    await this.$store.dispatch("basis/account/loadProfile");
    this.loading = false;
  }
}
export default MixinAccount;
